import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion'
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCardModule } from '@angular/material/card';
import { BiologicsFormComponent } from './biologics-form/biologics-form.component';
import { ContactLensMaterialFormComponent } from './contact-lens-material-form/contact-lens-material-form.component';
import { ModifiedSaltFormComponent } from './modified-salt-form/modified-salt-form.component';
import { RevisionToAdoptedUsanFormComponent } from './revision-to-adopted-usan-form/revision-to-adopted-usan-form.component';
import { SingleEntityDrugSaltFormComponent } from './single-entity-drug-salt-form/single-entity-drug-salt-form.component';
import { SingleEntityFormComponent } from './single-entity-form/single-entity-form.component';
import { FormHeaderComponent } from './common-sections/form-header/form-header.component';
import { FormTabsComponent } from './common-sections/form-tabs/form-tabs.component';
import { SuggestedNamesComponent } from './common-sections/basic-info/suggested-names/suggested-names.component';
import { InstructionsComponent } from './common-sections/basic-info/instructions/instructions.component';
import { FormSectionsNavComponent } from './common-sections/form-sections-nav/form-sections-nav.component';
import { FormLeftNavComponent } from './common-sections/form-left-nav/form-left-nav.component';
import { UsanFormsComponent } from './usan-forms/usan-forms.component';
import { FormNavButtonComponent } from './common-sections/form-nav-button/form-nav-button.component';
import { DesignationForSaltFormComponent } from './common-sections/basic-info/designation-for-salt-form/designation-for-salt-form.component';
import { SaveDraftButtonComponent } from './common-sections/save-draft-button/save-draft-button.component';
import { FormSectionSelectComponent } from './common-sections/form-section-select/form-section-select.component';
import { MolecularInfoComponent } from './common-sections/molecular-info/molecular-info/molecular-info.component';
import { ProDrugPrecursorComponent } from './common-sections/substance-details/pro-drug-precursor/pro-drug-precursor.component';
import { UniiNumberComponent } from './common-sections/substance-details/unii-number/unii-number.component';
import { TrademarksComponent } from './common-sections/substance-details/trademarks/trademarks.component';
import { TrivialNamesComponent } from './common-sections/substance-details/trivial-names/trivial-names.component';
import { ManufacturersComponent } from './common-sections/manufacturer-usage-info/manufacturers/manufacturers.component';
import { PrincipalTherapeuticUsesComponent } from './common-sections/manufacturer-usage-info/principal-therapeutic-uses/principal-therapeutic-uses.component';
import { PharmacologicActionComponent } from './common-sections/manufacturer-usage-info/pharmacologic-action/pharmacologic-action.component';
import { SubstanceBindsToTargetComponent } from './common-sections/manufacturer-usage-info/substance-binds-to-target/substance-binds-to-target.component';
import { PhaseOneTrialDateComponent } from './common-sections/clinical-trial-info/phase-one-trial-date/phase-one-trial-date.component';
import { IndAppNumbersComponent } from './common-sections/clinical-trial-info/ind-app-numbers/ind-app-numbers.component';
import { ExistingInnNameComponent } from './common-sections/clinical-trial-info/existing-inn-name/existing-inn-name.component';
import { ApplicantInfoComponent } from './common-sections/applicant-info/applicant-info/applicant-info.component';
import { InnExplanationComponent } from './common-sections/clinical-trial-info/inn-explanation/inn-explanation.component';
import { PaymentInfoComponent } from './common-sections/payment-info/payment-info/payment-info.component';
import { TermsConditionsComponent } from './common-sections/terms-conditions/terms-conditions/terms-conditions.component';
import { AgreeSubmitButtonComponent } from './common-sections/agree-submit-button/agree-submit-button.component';
import { UniiForSaltComponent } from './common-sections/substance-details/unii-for-salt/unii-for-salt.component';
import { UploadDocumentsComponent } from './common-sections/upload-documents/upload-documents/upload-documents.component';
import { AbsenceOfConflictComponent } from './common-sections/upload-documents/absence-of-conflict/absence-of-conflict.component';
import { CasRegistryInfoComponent } from './common-sections/upload-documents/cas-registry-info/cas-registry-info.component';
import { ProofOfPaymentComponent } from './common-sections/upload-documents/proof-of-payment/proof-of-payment.component';
import { NucleicAcidSaltsComponent } from './common-sections/upload-documents/nucleic-acid-salts/nucleic-acid-salts.component';
import { CoverLetterComponent } from './common-sections/upload-documents/cover-letter/cover-letter.component';
import { AdditionalDocumentationComponent } from './common-sections/upload-documents/additional-documentation/additional-documentation.component';
import { UploadFileDialogComponent } from './common-sections/dialogs/upload-file-dialog/upload-file-dialog.component';
import { SubstanceBindsNamesComponent } from './common-sections/manufacturer-usage-info/substance-binds-names/substance-binds-names.component';
import { RevisionToAdoptedUsanInstructionsComponent } from './common-sections/basic-info/revision-to-adopted-usan-instructions/revision-to-adopted-usan-instructions.component';
import { RevisionRequestNameComponent } from './common-sections/basic-info/revision-request-info/revision-request-info.component';
import { ChemicalNamesComponent } from './common-sections/basic-info/chemical-names/chemical-names.component';
import { StructuralFormulaComponent } from './common-sections/basic-info/structural-formula/structural-formula.component';
import { MolecularFormulaComponent } from './common-sections/molecular-info/molecular-formula/molecular-formula.component';
import { MolecularWeightComponent } from './common-sections/molecular-info/molecular-weight/molecular-weight.component';
import { CasRegistryComponent } from './common-sections/substance-details/cas-registry/cas-registry.component';
import { CodeDesignationsComponent } from './common-sections/substance-details/code-designations/code-designations.component';
import { StatementOfAdoptionComponent } from './common-sections/upload-documents/statement-of-adoption/statement-of-adoption.component';
import { PolymerPresenceDisclosureComponent } from './common-sections/polymer-presence-disclosure/polymer-presence-disclosure.component';
import { SemiInterpenetratingNetworkDisclosureComponent } from './common-sections/semi-interpenetrating-network-disclosure/semi-interpenetrating-network-disclosure.component';
import { DegreeOfPolymerizationComponent } from './common-sections/degree-of-polymerization/degree-of-polymerization.component';
import { ChemicalsAttachedComponent } from './common-sections/chemicals-attached/chemicals-attached.component';
import { ManufacturingProcessComponent } from './common-sections/manufacturing-process/manufacturing-process.component';
import { PurityOf2HydroxyethylMethacrylateComponent } from './common-sections/purity-of-2-hydroxyethyl-methacrylate/purity-of-2-hydroxyethyl-methacrylate.component';
import { WaterContentComponent } from './common-sections/water-content/water-content.component';
import { OxygenPermeabilityComponent } from './common-sections/oxygen-permeability/oxygen-permeability.component';
import { SystematicNamesDescriptionComponent } from './common-sections/systematic-names-description/systematic-names-description.component';
import { SequenceComponent } from './common-sections/upload-documents/sequence/sequence.component';
import { AntibodyDrugConjugatesComponent } from './common-sections/upload-documents/antibody-drug-conjugates/antibody-drug-conjugates.component';
import { PegylatedNucleicAcidBasedSubstancesComponent } from './common-sections/upload-documents/pegylated-nucleic-acid-based-substances/pegylated-nucleic-acid-based-substances.component';
import { CellTherapiesComponent } from './common-sections/upload-documents/cell-therapies/cell-therapies.component';
import { FormDetailComponent } from './form-detail/form-detail.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfirmDeleteDialogComponent } from './common-sections/dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { MatMenuModule } from '@angular/material/menu';
import { UploadedFileComponent } from 'app/ui-components/uploaded-file/uploaded-file.component';
import { MatButtonModule } from '@angular/material/button';
import { MolecularFormulaDialogComponent } from './common-sections/upload-documents/molecular-formula-dialog/molecular-formula-dialog.component';
import { IndTherapeuticClaimComponent } from './common-sections/substance-details/ind-therapeutic-claim/ind-therapeutic-claim.component';
import { TrademarkSearchResults } from './common-sections/upload-documents/trademark-search-results/trademark-search-results.component';
import { SequenceAntibodiesComponent } from './common-sections/upload-documents/sequence-antibodies/sequence-antibodies.component';
import { SequenceNucleicAcidComponent } from './common-sections/upload-documents/sequence-nucleic-acid/sequence-nucleic-acid.component';
import { GeneTherapiesComponent } from './common-sections/upload-documents/gene-therapies/gene-therapies.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    FormLeftNavComponent,
    SingleEntityDrugSaltFormComponent,
    SingleEntityFormComponent,
    ModifiedSaltFormComponent,
    RevisionToAdoptedUsanFormComponent,
    ContactLensMaterialFormComponent,
    BiologicsFormComponent,
    FormHeaderComponent,
    FormTabsComponent,
    SuggestedNamesComponent,
    FormSectionsNavComponent,
    InstructionsComponent,
    UsanFormsComponent,
    FormNavButtonComponent,
    DesignationForSaltFormComponent,
    SaveDraftButtonComponent,
    FormSectionSelectComponent,
    MolecularInfoComponent,
    ProDrugPrecursorComponent,
    UniiNumberComponent,
    TrademarksComponent,
    TrivialNamesComponent,
    ManufacturersComponent,
    PrincipalTherapeuticUsesComponent,
    PharmacologicActionComponent,
    SubstanceBindsToTargetComponent,
    PhaseOneTrialDateComponent,
    IndAppNumbersComponent,
    ExistingInnNameComponent,
    ApplicantInfoComponent,
    InnExplanationComponent,
    PaymentInfoComponent,
    TermsConditionsComponent,
    AgreeSubmitButtonComponent,
    UniiForSaltComponent,
    UploadDocumentsComponent,
    AbsenceOfConflictComponent,
    CasRegistryInfoComponent,
    ProofOfPaymentComponent,
    NucleicAcidSaltsComponent,
    CoverLetterComponent,
    AdditionalDocumentationComponent,
    UploadFileDialogComponent,
    SubstanceBindsNamesComponent,
    RevisionToAdoptedUsanInstructionsComponent,
    RevisionRequestNameComponent,
    ChemicalNamesComponent,
    StructuralFormulaComponent,
    MolecularFormulaComponent,
    MolecularWeightComponent,
    CasRegistryComponent,
    CodeDesignationsComponent,
    StatementOfAdoptionComponent,
    PolymerPresenceDisclosureComponent,
    SemiInterpenetratingNetworkDisclosureComponent,
    DegreeOfPolymerizationComponent,
    ChemicalsAttachedComponent,
    ManufacturingProcessComponent,
    PurityOf2HydroxyethylMethacrylateComponent,
    WaterContentComponent,
    OxygenPermeabilityComponent,
    SystematicNamesDescriptionComponent,
    SequenceComponent,
    SequenceAntibodiesComponent,
    SequenceNucleicAcidComponent,
    AntibodyDrugConjugatesComponent,
    PegylatedNucleicAcidBasedSubstancesComponent,
    CellTherapiesComponent,
	  FormDetailComponent,
    ConfirmDeleteDialogComponent,
    UploadedFileComponent,
    MolecularFormulaDialogComponent,
    IndTherapeuticClaimComponent,
    TrademarkSearchResults,
    GeneTherapiesComponent
  ],
  imports: [
    CommonModule,
    DragDropModule,
    ScrollingModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatSidenavModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatMenuModule,
    MatButtonModule,
    MatTooltipModule
  ],
  providers: [
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'} }
  ]
})
export class UsanFormsModule { }
